<template>
	<div>
		<Billingcomponent
			:outerVisible="outerVisible"
			@closeouterVisible="closeouterVisible"
			@InvoiceBackInformation="InvoiceBackInformation"
			:title="title"
			:ruleFormb="allitem.ruleFormb"
			:iszhengshu="false"
			:priceall="allitem.priceall"
			:totalall="allitem.totalall"
			:ruleFormbxiao="allitem.ruleFormbxiao"
			:form_chae="allitem.form_chae"
			:bztext="allitem.bztext"
			:stateall="allitem.stateall"
			:listoflists="allitem.listoflists"
			:invoiceNo="allitem.invoiceNo"
			:invoiceCode="allitem.invoiceCode"
			:billingDate="allitem.billingDate"
			:checkCode="allitem.checkCode"
			:HongChongtype="HongChongtype"
			:beizDisable="beizDisable"
		></Billingcomponent>
		<el-dialog title="审核成功" :visible.sync="finishdialog" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" v-dialogDrag>
			<!-- <minhead :headtitle="finishtitle" :isdiag="true"></minhead> -->
			<div class="Verticalcenter"><img src="../../../assets/img/finishpic.png" width="391px" height="287px" /></div>
			<div class="forfinishsuceess">审核通过</div>
			<div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<div class="rightbuttom"><div @click="finishdialog = false">确认</div></div>
			</div>
		</el-dialog>
		<kgdiag
			@closekgdialog="closekgdialog"
			:headtitle="kgtitle"
			:kgdialog="kgdialog"
			:tableDatans="tableDatans"
			:tableDatakp="tableDatakp"
			@openInvoice="doRedLetterVat('编辑发票')"
			@radiochange="radiochange"
		></kgdiag>
		<!-- 修改自定义说明二修改 -->
		<el-dialog title="修改自定义说明二" :visible.sync="dialogApproval" width="100px;" v-dialogDrag>
			<taxform :Formlist="formlist" ref="taxForm" :formdata="formdata"></taxform>
			<div style="justify-content: center;margin-top: 40px; display: flex;">
				<div class="backstyle" style="margin-right: 30px;margin-left: 30px; margin-bottom: 20px;" @click="dialogApproval = false">返回</div>
				<div class="addstyle" style="margin-bottom: 20px;" @click="submitFrom">提交</div>
			</div>
		</el-dialog>
		<taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai"></taxSearch>
<div class="headline"></div>
		<div class="areacontent" >
			<div class="">
				<div class="Centerupdown">
					<div class="between-line">
						<!-- <el-button type="primary" plain @click="forshuai()" style="width: 100px;">查询</el-button> -->
						<!-- <el-button type="primary" plain @click="resetForm()" style="width: 100px;margin-right: 10px;">重置</el-button> -->
						<el-dropdown style="width: 100px;margin-right: 10px;" v-permission="fpfstk_fszptk_hc">
							<!-- <el-button type="primary" plain style="width: 100px; padding-left:30px;">
								红冲
								<i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i>
							</el-button> -->
							<div class="addstyle" style="width: 100px;margin-right: 10px;">
								<samp>
									红冲
									<i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i>
								</samp>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="plhc(1)">红冲</el-dropdown-item>
								<el-dropdown-item @click.native="plhc(2)">红冲重开</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<!-- <el-button style="margin-left: 5px;" type="primary" plain @click="openUpdateZidysm2()">修改自定义说明二</el-button> -->
						<div class="addstyle" @click="openUpdateZidysm2()" style="width: 130px;margin-right: 10px;"><samp>修改自定义说明二</samp></div>
					</div>
				</div>
			</div>
			<!-- 	<div class="end-flex"  style="margin-top: 20px">
				<div class="Centerupdown">
          <el-dropdown style="width: 120px;margin-right: 10px;" v-permission='fpfstk_fszptk_qzhckz'>
            <el-button type="primary"  plain  style="width: 120px; "> 强制红冲控制
              <i class="el-icon-caret-bottom el-icon--right" ></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="updateRedBluntSign(1)">置为强制红冲</el-dropdown-item>
              <el-dropdown-item @click.native="updateRedBluntSign(0)">取消强制红冲</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown style="width: 100px;margin-right: 10px;" v-permission='fpfstk_fszptk_hc'>
            <el-button type="primary"  plain  style="width: 100px; padding-left:30px;"> 红冲
              <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="plhc(1)">红冲</el-dropdown-item>
              <el-dropdown-item @click.native="plhc(2)">红冲重开</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
				</div>
        <div class="Centerupdown">
          <el-button style="margin-left: 5px;" type="primary" plain @click="openUpdateZidysm2()">
            修改自定义说明二
          </el-button>
        </div>
			</div> -->
			<div class="areatable">
				<div class="tableh">
					<el-table
						:data="tableData"
						border
						height="calc(100vh - 437px )"
						ref="multipleTable"
						@selection-change="handleSelectionChange"
						@row-click="selectClick"
						@sort-change="tableSortChange"
					>
						<el-table-column type="selection" width="55" fixed="left"></el-table-column>
						<el-table-column prop="xinxbbh" align="left" min-width="160px" show-overflow-tooltip label="红字信息表编号"></el-table-column>
						<el-table-column label="发票类型" prop="faplxdm" sortable="custom" min-width="100" align="center">
							<template slot-scope="scope">
								<p v-if="scope.row.faplxdm == '026'">电子普票</p>
								<p v-if="scope.row.faplxdm == '028'">电子专票</p>
								<p v-if="scope.row.faplxdm == '007'">纸质普票</p>
								<p v-if="scope.row.faplxdm == '004'">纸质专票</p>
							</template>
						</el-table-column>
						<el-table-column prop="forceRedFlushStatus" label="强制红冲状态" min-width="100" align="center" key="3">
							<template slot-scope="scope">
								<p v-if="scope.row.forceRedFlushStatus != '1'">否</p>
								<p v-if="scope.row.forceRedFlushStatus == '1'">是</p>
							</template>
						</el-table-column>
						<el-table-column prop="yuanfpdm" sortable="custom" label="原发票代码" min-width="110" align="center"></el-table-column>
						<el-table-column prop="yuanfphm" sortable="custom" label="原发票号码" min-width="110" align="center"></el-table-column>

						<el-table-column prop="goufmc" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="goufsbh" label="购方税号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="yuanHejje" label="原开金额" align="right" min-width="100">
							<template slot-scope="scope">
								<span>{{ toThousands(Amountformat(scope.row.yuanHejje)) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="yuanHejse" label="原开税额" align="right" min-width="100">
							<template slot-scope="scope">
								<span>{{ toThousands(Amountformat(scope.row.yuanHejse)) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="yuanJiashj" label="原开价税合计" align="right" min-width="100">
							<template slot-scope="scope">
								<span>{{ toThousands(Amountformat(scope.row.yuanJiashj)) }}</span>
							</template>
						</el-table-column>
						<el-table-column label="开票日期" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ yyyyMMdd(scope.row.yuanKprq) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="hejje" label="实开金额" align="right" min-width="100">
							<template slot-scope="scope">
								<span>{{ toThousands(Amountformat(scope.row.hejje)) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="hejse" label="实开税额" align="right" min-width="100">
							<template slot-scope="scope">
								<span>{{ toThousands(Amountformat(scope.row.hejse)) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="jiashj" label="实开价税合计" align="right" min-width="100">
							<template slot-scope="scope">
								<span>{{ toThousands(Amountformat(scope.row.jiashj)) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="zhidr" label="制单人" min-width="100" align="center"></el-table-column>
						<el-table-column prop="zidysm" label="自定义说明" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="zidysm2" label="自定义说明二" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="kaipzddm" label="税盘编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column label="操作" align="center" width="200" fixed="right">
							<template slot-scope="scope">
								<div class="Centerupdown">
									<el-button type="text" @click="handleClick(scope.row, '预览原发票')" size="small" v-permission="fpfstk_fszptk_ckyp">查看原票</el-button>
									<!--									<el-button @click="forhongchongAudit(scope.row)" type="text" size="small" style="color: red;">红冲</el-button>-->
									<el-button type="text" @click.stop="plhcOne(scope.row)" size="small" v-permission="fpfstk_fszptk_hcck">红冲重开</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="lastend">
					<div>
						当前已勾选
						<span>{{ selectCount }}</span>
						条
					</div>
					<div>
						合计金额
						<span>{{ toThousands(Amountformat(selectJine)) }}</span>
					</div>
					<div>
						合计税额
						<span>{{ toThousands(Amountformat(selectShuie)) }}</span>
					</div>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						:key="elementui_page_component_key"
						:current-page="currentpage"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import configHttp from '../../../../configHttp';

export default {
	components: {},
	data() {
		return {
			searchlist: [
				{
					prop: 'faplxdm',
					label: '发票类型',
					type: 'select',
					selectval: [
						{
							label: '电子专票',
							value: '028'
						},
						{
							label: '纸质专票',
							value: '004'
						},
						{
							label: '全部',
							value: ''
						}
					]
				},
				{
					prop: 'yuanfphm',
					label: '原发票号码',
					type: 'input'
				},
				{
					prop: 'yuanfpdm',
					label: '原发票代码',
					type: 'input'
				},

				{
					prop: 'fpalldate',
					label: '开票日期',
					type: 'date',
					valueformat: 'yyyyMMdd'
				},
				{
					prop: 'goufmc',
					label: '购方名称',
					type: 'input'
				},
				{
					prop: 'goufsbh',
					label: '购方税号',
					type: 'input'
				},
				{
					prop: 'xinxbbh',
					label: '红字信息表编号',
					type: 'input'
				},

				{
					prop: 'zidysm',
					label: '自定义说明',
					type: 'input'
				},
				{
					prop: 'yuanHejje',
					label: '原金额',
					type: 'input'
				},
				{
					prop: 'yuanHejse',
					label: '原税额',
					type: 'input'
				},
				{
					prop: 'kaipzddm',
					label: '税盘编号',
					type: 'input'
				},
				{
					prop: 'forceRedFlushStatus',
					label: '强制红冲状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '是',
							value: '1'
						},
						{
							label: '否',
							value: '0'
						}
					]
				}
			],

			isshou: true,
			kgdialog: false,
			kgtitle: ['红冲'],
			tableDatans: [{}],
			tableDatakp: [{}],
			formLabelWidth: '150px',
			cxdialog: false,
			daoin: false,
			daodownload: false,
			/* 开具弹框 */
			page: 1,
			pagenum: 10,
			currentpage: 1,
			elementui_page_component_key: '',
			totalcount: 0,
			serchformRules: {
				hejse: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
				hejje: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
				goufsbh: [{ validator: this.validateCustomersbh, trigger: 'blur' }],
				xiaofsbh: [{ validator: this.validateCustomersbh, trigger: 'blur' }],
				yuanfpdm: [{ validator: this.validateFapdm, trigger: 'blur' }],
				yuanfphm: [{ validator: this.validateFaphm, trigger: 'blur' }]
			},
			dateall: '',
			tableData: [],
			headtitle: ['发票管理', '负数专票填开'],
			cxtitle: ['高级查询'],
			serchval: '',
			title: '',
			allitem: {},
			outerVisible: false,
			chooseitem: {},
			deletecommids: '',
			/* 高级查询搜索条件 */
			searchalllist: {
				docNo: '',
				docStartDate: '',
				docEndDate: '',
				excludeTaxAmount: '',
				includeTaxAmount: '',
				purchaserName: '',
				type: '2',
				purchaserTaxNumber: '',
				reviewer: '',
				faplxdm: '',
				issuer: '',
				payee: '',
				billingStartdate: '',
				billingEnddate: '',
				fpalldate: '',
				Documentstatus_g: '',
				//搜索
				listlikeSearch: '',
				kaipzddm: '',
				forceRedFlushStatus: ''
			},
			daodownloadtitle: ['红字信息表下载'],
			daointitle: ['红字信息表导入'],
			selectCount: '0',
			selectJine: '0.00',
			selectShuie: '0.00',
			selectRow: {},
			selectRows: [],
			HongChongtype: 'zhuan',
			kaipzddm: '',
			selectShenqzt: [],
			dialogType: '',
			finishdialog: false,
			finishtitle: '审核成功',
			tableHeight: '',
			fpxlxoptions: [
				{
					label: '电子专票',
					value: '028'
				},
				{
					label: '纸质专票',
					value: '004'
				},
				{
					label: '全部',
					value: ''
				}
			],
			isQuery: false,
			// 红冲类型 ：1、红冲 2、红冲重开
			type: '',
			formlist: [
				{
					prop: 'text',
					label: '修改自定义说明二',
					type: 'textarea',
					isnotnull: true
				}
			],
			formdata: {
				text: ''
			},
			dialogApproval: false,
			sort: 'desc',
			order: 'id',
			beizDisable: true
		};
	},
	created() {
		// this.getRedLetterInfoList();
		this.initSelectShenqzt();
	},
	mounted() {
		this.repairtable();
	},
	methods: {
		repairtable() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheightzhengshutiankai();
				setTimeout(() => {
					this.$refs.multipleTable.doLayout();
				}, 300);
				window.onresize = () => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
				};
			});
		},
		plhcOne(row) {
			// this.kaijuType="batch";
			this.type = '2';
			this.selectRows = [row];
			this.forhongchongAudit(row);
		},
		plhc(type) {
			this.type = type;
			if (this.emptyandnull(this.selectRows)) {
				this.$message.error('请选择红冲的单据');
				return false;
			}
			if (1 == this.selectRows.length) {
				this.forhongchongAudit(this.selectRows[0]);
				return;
			}
			this.$confirm('此操作将进行批量红冲, 是否继续?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// this.doRedLetterBatch()
				this.getKaipjList().then(res => {
					//this.getCurrntDocInfo();
					// this.doOneRedLetterBatch();
				});
			});
		},
		doRedLetterBatch() {
			var ids = [];
			this.selectRows.forEach(item => {
				ids.push(item.id);
			});
			this.$https.fetchPost('/redLetter/doRedLetterBatchVat', ids).then(res => {
				if (res.data.success) {
					this.$refs.multipleTable.clearSelection();
					this.selectCount = 0;
					this.selectRows = [];
					this.kgdialog = false;
					this.getRedLetterInfoList();
				}
			});
		},
		handleSelectionChange(e) {
			this.selectCount = 0;
			this.selectJine = 0;
			this.selectShuie = 0;
			let hejje = 0;
			let hejse = 0;
			let count = 0;
			this.selectRows = [];
			e.forEach((item, index) => {
				count++;
				hejje += parseFloat(item.hejje);
				hejse += parseFloat(item.hejse);
				this.selectRows.push(item);
			});
			this.selectCount = count;
			this.selectJine = hejje;
			this.selectShuie = hejse;
		},
		selectClick(row, column, event) {
			this.$refs.multipleTable.toggleRowSelection(row);
		},
		fordaochu() {
			console.log('导出列表');
		},
		changeshou() {
			this.isshou = !this.isshou;
		},
		//重置
		resetForm(formName) {
			Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
		},
		forshuai() {
			this.isQuery = true;
			this.elementui_page_component_key++;
			this.currentpage = 1;
			this.page = 1;
			if (this.searchalllist.fpalldate) {
				this.searchalllist.tiankrqStart = this.searchalllist.fpalldate[0];
				this.searchalllist.tiankrqEnd = this.searchalllist.fpalldate[1] + '235959';
			}
			this.getRedLetterInfoList();
		},
		tableSortChange(column, prop, order) {
			this.order = column.prop;
			if (column.order) {
				this.sort = column.order.replace('ending', '');
			} else {
				this.sort = '';
				this.order = '';
			}
			this.getRedLetterInfoList();
		},
		/* 接口数据 */
		/* 获取开票管理表格区列表数据 */
		getRedLetterInfoList() {
			var newform = JSON.parse(JSON.stringify(this.searchalllist));
			delete newform['fpalldate'];
			newform.type = '2';
            newform.fapzl = "1";
			let params = {
				likeSearch: this.searchalllist.listlikeSearch,
				page: this.page,
				limit: this.pagenum,
				sort: this.sort,
				order: this.order,
				search: newform
			};
			if (configHttp.shuangRiTaxNumber) {
				let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
				console.log(shuangRiTaxNumber);
				let userobj = JSON.parse(localStorage.getItem('useropj'));
				let qiybh = userobj.currCompany.code;
				if (shuangRiTaxNumber.includes(qiybh)) {
					params.search.cank2 = '3';
				}
			}
			this.$https.fetchPost('/redLetter/getRedLetterInfoList', params).then(res => {
				this.tableData = res.data.data;
				this.tableData.forEach(row => {
					row.redLetterInvoiceDetails.forEach(detail => {
						if (detail.shangpbmjc != null && detail.shangpbmjc != '') {
							let dl = '*' + detail.shangpbmjc + '*';
							if (detail.shangpmc.indexOf(dl) == -1) {
								detail.shangpmc = dl + detail.shangpmc;
							}
						}
					});
				});
				this.totalcount = res.data.count;
				this.cxdialog = false;
				this.$nextTick(() => {
					this.tableHeight = this.diagheight();
					this.$refs.multipleTable.doLayout();
					window.onresize = () => {
						this.tableHeight = this.diagheight();
						this.$refs.multipleTable.doLayout();
					};
				});
			});
		},
		/* table选中发生改变 */

		/* 开票管理表格区--发票预览 */
		handleClick(row, title) {
			this.HongChongtype = '';
			this.title = title;
			console.log(row);
			let faphm = '';
			let fapdm = '';
			if ('预览原发票' == title) {
				faphm = row.yuanfphm;
				fapdm = row.yuanfpdm;
			} else if ('预览发票' == title) {
				if (row.shenqzt !== '3') {
					this.$message.error(this.$tolertJSON['006-4']);
					return;
				}
				faphm = row.faphm;
				fapdm = row.fapdm;
			}
			let params = {
				faphm: faphm,
				fapdm: fapdm
			};
			this.title = '预览发票';
			this.$https.fetchPost('/redLetter/getRealDocInfoPreview', params).then(res => {
				if (res.data.success) {
					console.log(res.data.obj);
					this.allitem = JSON.parse(JSON.stringify(res.data.obj));
					this.outerVisible = true;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 电专红冲 */
		doRedLetterVat(title) {
			this.dialogType = 'redLetter';
			this.HongChongtype = 'zhuan';
			this.title = title;
			this.$https.fetchPost('/redLetter/getRedLetterPageInfoVat', this.selectRow).then(res => {
				if (res.data.success) {
					console.log(res.data.obj);
					this.allitem = JSON.parse(JSON.stringify(res.data.obj));
					this.allitem.priceall.forEach((item, index) => {
						item.quantity = -item.quantity;
					});
					this.outerVisible = true;
				}
			});
		},

		/* 发票返回信息 */
		InvoiceBackInformation(e) {
			this.dialogType = 'redLetter';
			//	获取开票机信息
			//this.getKaipjList().then(res => {
			//	获取发票库存
			let fs = 1;
			var faplxdm = this.selectRow.faplxdm;
			var message = '当前发票代码：fapdm，发票号码:faphm，';
			if (fs > 1) {
				message += '开票份数：' + fs + '份，';
			}
			message += '库存kuc份，是否继续开票？';
			let kaipzddm = this.selectRow.kaipzddm;

			let jsonstr = {
				faplxdm: faplxdm,
				kaipzddm: kaipzddm
			};
			faplxdm = JSON.stringify(jsonstr);

			// let fplx = faplxdm
			this.$https.fetchPost('/doc/getCurrentInvoiceInfo', faplxdm).then(res => {
				if (res.data.success) {
					var obj = res.data.obj;
					message = message.replace('fapdm', obj.fapdm);
					if (fs > 1) {
						var endfaphm = parseInt(obj.faphm) + parseInt(fs) - 1;
						message = message.replace('faphm', obj.faphm + '-' + endfaphm);
					} else {
						message = message.replace('faphm', obj.faphm);
					}
					message = message.replace('kuc', obj.kuc);

					this.$confirm(message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							//  红冲操作
							this.doSingleRedLetter(e);
						})
						.catch(() => {});

					// this.doSingleRedLetter(e);
				}
			});
		},
		doSingleRedLetter(e) {
			let params;
			switch (this.dialogType) {
				case 'redLetter':
					params = {
						fapJson: JSON.stringify(e),
						kaipzddm: this.selectRow.kaipzddm,
						redLetterInfoPojo: { redLetterId: this.selectRow.id }
					};
					this.$https.fetchPost('/redLetter/doRedLetterVat', params).then(res => {
						if (res.data.success) {
							this.$message.success(this.$tolertJSON[4022]);
							this.doBlueLetterReset(this.selectRow);
							this.getRedLetterInfoList();
							this.outerVisible = false;
							this.kgdialog = false;
						}
					});
					break;
				case 'audit':
					params = {
						redLetterInfoPojo: { redLetterId: this.selectRow.id }
					};
					this.$https.fetchPost('/redLetter/doRedLetterVatAudit', params).then(res => {
						if (res.data.success) {
							this.doBlueLetterReset(this.selectRow);
							this.getRedLetterInfoList();
							this.outerVisible = false;
							this.kgdialog = false;
							this.finishdialog = true;
						}
					});
					break;
			}
		},
		/* 关闭开票弹框 */
		closeouterVisible() {
			this.outerVisible = false;
		},
		initSelectShenqzt() {
			this.$https.fetchPost('config/getSelectByKey', 'REDLETTER_SHENQZT').then(res => {
				this.selectShenqzt = this.setSelectKey(JSON.parse(res.data.obj));
			});
		},
		forhongchongAudit(row) {
			this.selectRow = JSON.parse(JSON.stringify(row));
			this.dialogType = 'audit';
			this.HongChongtype = 'zhuan';
			this.title = '编辑发票';
			this.$https.fetchPost('/redLetter/getRedLetterPageInfoVat', this.selectRow).then(res => {
				if (res.data.success) {
					this.allitem = JSON.parse(JSON.stringify(res.data.obj));
					let isQd = this.allitem.stateall.isqingdan;
					if (isQd) {
						this.allitem.listoflists.forEach((item, index) => {
							if (item.quantity > 0) {
								item.quantity = -item.quantity;
							}
						});
					} else {
						this.allitem.priceall.forEach((item, index) => {
							if (item.quantity > 0) {
								item.quantity = -item.quantity;
							}
						});
					}
					this.allitem.stateall.choosetitleindex = this.selectRows[0].faplxdm;
					console.log('====================>1', this.allitem.stateall);
					console.log('====================>2', this.selectRows);
					// this.$https.fetchPost("/doc/getKaipjByKaipjbh",{kaipjbh:this.selectRows[0].kaipzddm}).then(res => {
					//     if (res.data.success) {
					//         let kpj = res.data.obj;
					//         if (kpj.equipmentType !='' && kpj.equipmentType != null) {
					//           if (kpj.equipmentType == '0') {
					//               this.allitem.bztext = '开具红字增值税专用发票信息表编号' + this.selectRows[0].xinxbbh;
					//           } else if (kpj.equipmentType == '1') {
					//               this.allitem.bztext = '红字发票信息表编号' + this.selectRows[0].xinxbbh;
					//           } else if (kpj.equipmentType == '2') {
					//               this.allitem.bztext = '红字发票信息表编号:' + this.selectRows[0].xinxbbh;
					//           }
					//         }
					//     }
					// })
					this.beizDisable = false;
					this.outerVisible = true;
				}
			});
		},
		radiochange(row) {
			this.kaipzddm = row.kaipjbh;
		},
		/* 子传父 */
		closekgdialog(e) {
			this.kgdialog = e;
		},
		fordaoru() {
			this.daoin = true;
		},
		fordaodownload() {
			this.daodownload = true;
		},
		/* 筛选 */
		forserchshai() {
			this.cxdialog = false;
		},
		forcloseshai() {
			this.cxdialog = false;
		},
		handleSizeChange(val) {
			this.pagenum = val;
			if (this.isQuery) {
				this.getRedLetterInfoList();
			}
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getRedLetterInfoList();
		},
		/* 高级查询弹框	 */
		forserch() {
			this.cxdialog = true;
		},
		redLetterInfoDownLoad() {
			let parms = {
				redLetterInfoPojo: { tiankrq: this.dateall }
			};
			this.$https.fetchPost('/redLetter/redLetterInfoDownLoad', parms).then(res => {
				if (res.data.success) {
					this.getRedLetterInfoList();
					this.$message.success(this.$tolertJSON['006-1']);
					this.daodownload = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		async getKaipjList() {
			//	获取开票机信息
			this.$https.fetchPost('/doc/getKaipjList').then(res => {
				console.log(JSON.parse(res.data.obj));
				this.tableDatakp = JSON.parse(res.data.obj);
				// 选择开票机dialog隐藏
				this.kgdialog = true;

				// if (this.tableDatakp && this.tableDatakp.length > 0) {
				//   this.kaipzddm = this.tableDatakp[0].kaipjbh;
				// }
			});
		},
		//单张循环红冲重开
		async doOneRedLetterBatch() {
			let successCount = 0;
			let errorCount = 0;
			let errorMsg = ',其中：';
			for (var i = 0; i < this.selectRows.length; i++) {
				let item = this.selectRows[i];
				let object = {
					id: item.id,
					type: this.type
				};
				let jsonObject = JSON.stringify(object);
				await this.$https.fetchPost('/redLetter/doOneRedLetterBatchVat', jsonObject).then(res => {
					if (res.data.success) {
						//成功
						successCount++;
					} else {
						// 失败
						errorCount++;
						errorMsg += res.data.message + ';';
					}
				});
			}
			let resultMsg = '共红冲【' + this.selectRows.length + '】张发票，成功【' + successCount + '】条，失败【' + errorCount + '】条 ';
			if (errorCount > 0) {
				resultMsg += errorMsg;
			}
			this.$refs.multipleTable.clearSelection();
			this.selectCount = 0;
			this.selectRows = [];
			this.kgdialog = false;
			this.getRedLetterInfoList();
			this.$message({
				showClose: true,
				message: resultMsg,
				type: errorCount > 0 ? 'error' : 'success'
			});
		},
		getOneCurrntDocInfo() {
			var faplxdm = this.selectRows[0].faplxdm;
			try {
				this.selectRows.forEach(item => {
					if (faplxdm !== item.faplxdm) {
						throw new Error('只能对相同类型发票进行红冲操作！');
					}
				});
			} catch (err) {
				this.$message.error(err.message);
				return;
			}
			this.getOpenInvoiceMessage(faplxdm, this.selectRows.length);
		},
		getOpenInvoiceMessage(faplxdm, fs) {
			var message = '当前发票代码：fapdm，发票号码:faphm，';
			if (fs > 1) {
				message += '开票份数：' + fs + '份，';
			}
			message += '库存kuc份，是否继续开票？';
			let kaipzddm = this.selectRows[0].kaipzddm;
			let jsonstr = {
				faplxdm: faplxdm,
				kaipzddm: kaipzddm
			};
			faplxdm = JSON.stringify(jsonstr);
			this.$https.fetchPost('/doc/getCurrentInvoiceInfo', faplxdm).then(res => {
				if (res.data.success) {
					var obj = res.data.obj;
					message = message.replace('fapdm', obj.fapdm);
					if (fs > 1) {
						var endfaphm = parseInt(obj.faphm) + parseInt(fs) - 1;
						message = message.replace('faphm', obj.faphm + '-' + endfaphm);
					} else {
						message = message.replace('faphm', obj.faphm);
					}
					message = message.replace('kuc', obj.kuc);
					this.doOpenInvoiceDialog(message);
				}
			});
		},
		doOpenInvoiceDialog(message) {
			this.$confirm(message, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					// switch (this.kaijuType) {
					// case 'single':
					// 	this.doRedLetter("编辑发票");
					// 	break;
					// case 'batch':
					//this.doRedLetterBatch(); //	批量红冲
					this.doOneRedLetterBatch(); //单张循环红冲重开
					// 	break;
					// }
				})
				.catch(() => {});
		},
		//重开单据
		doBlueLetterReset(row) {
			console.log('row:' + JSON.stringify(row));
			let type = this.type;
			if (type != 2) {
				return;
			}
			let params = {
				yfapdm: row.yuanfpdm,
				yfaphm: row.yuanfphm,
				type: 1,
				fplx: 2
			};
			this.$https.fetchPost('/redLetter/doBlueLetterReset', JSON.stringify(params)).then(res => {
				if (res.data.success) {
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		submitFrom() {
			var param = {};
			var ids = [];
			this.selectRows.forEach(item => {
				ids.push(item.id);
			});
			param.ids = ids;
			param.text = this.formdata.text;

			this.$https.fetchPost('/doc/updateZidysm2', param).then(res => {
				if (res.data.success) {
					this.dialogApproval = false;
					this.getRedLetterInfoList();
				}
			});
		},
		//修改自定义说明二
		openUpdateZidysm2() {
			if (this.selectCount < 1) {
				this.$message({
					type: 'error',
					message: '请选择需要修改自定义说明的单据。'
				});
				return;
			}
			this.dialogApproval = true;
			if (this.$refs.taxform) {
				this.$nextTick(() => {
					this.$refs.taxform.clearValidate();
				});
			}
		}, //强制红冲修改状态
		updateRedBluntSign(state) {
			if (this.selectCount < 1) {
				this.$message({
					type: 'error',
					message: '请选择需要控制红冲的单据。'
				});
				return;
			}
			var message;
			if (state == 1) {
				message = '此操作将发票置为强制红冲状态，红冲时可能存在重复红冲风险，是否继续？';
			} else {
				message = '是否确定取消强制红冲？';
			}
			this.$confirm(message, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					var param = {};
					var ids = new Array();
					var isSuccess = false;
					this.selectRows.forEach(item => {
						if (item.docId) {
							ids.push(item.docId);
						} else {
							isSuccess = true;
						}
					});
					if (isSuccess) {
						this.$message({
							type: 'error',
							message: '当前有红字申请单未关联到发票，请修改后提交。'
						});
						return;
					}
					param.state = state;
					param.ids = ids;
					this.$https.fetchPost('/doc/updateForceRedFlushStatus', param).then(res => {
						if (res.data.success) {
							this.getRedLetterInfoList();
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/.el-input--suffix .el-input__inner {
	padding-right: 25px;
}
.shousuo:extend(.Verticalcenter) {
	height: 20px;
	margin-bottom: 10px;
	background-color: #f8f8f8;
}
.shousuo:hover {
	background: #f8f8f8;
}
.minheight {
	height: 50px;
	overflow: hidden;
	transition: all 0.3s ease;
}
.maxheight {
	height: 150px;
	overflow: hidden;
	transition: all 0.3s ease;
}
/deep/ .el-dialog__body {
	padding: 0px 20px;
}

.bt1 {
	width: 56px;
	height: 30px;
	border: 1px solid #e5e5e5;
	border-radius: 3px;
	font-size: 14px;
	font-weight: 500;
	color: #2f66fc;
}

.bt2 {
	width: 93px;
	height: 32px;
	background: #2f66fc;
	border-radius: 2px;
	font-size: 15px;
	font-weight: 400;
	cursor: pointer;
	color: #ffffff;
}

.bt3 {
	width: 93px;
	height: 32px;
	background: #e2e2e2;
	border-radius: 2px;
	font-size: 15px;
	font-weight: 400;
	cursor: pointer;
	margin-left: 53px;
	color: #ffffff;
}

/* /deep/.el-dialog__body{
        padding: 0;
    } */

/deep/ .el-table--small td {
	padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
	min-height: 160px;
}

.noneheader /deep/ .el-dialog__header {
	display: none;
}

.areatable {
	margin-top: 16px;
}

.aftericon:extend(.Centerhorizontally) {
	width: 36px;
	height: 33px;
	background: #ffffff;
	box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
	opacity: 1;
	border-radius: 3px;
	margin-left: 20px;
}

.aftericon > img {
	width: 16px;
	height: 16px;
}

.areacontent {
	margin-left: 21px;
}
</style>
